"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFactory = void 0;
var buffer_1 = require("buffer");
var Data_1 = require("./Data");
var Str_1 = require("./Str");
var U32_1 = require("./U32");
var Int64_1 = require("./Int64");
var UInt64_1 = require("./UInt64");
var DataHash_1 = require("./DataHash");
var DataSignature_1 = require("./DataSignature");
var DataLock_1 = require("./DataLock");
var DataPublicKey_1 = require("./DataPublicKey");
var Dictionary_1 = require("./Dictionary");
var DataList_1 = __importDefault(require("./DataList"));
var DataFactory = /** @class */ (function (_super) {
    __extends(DataFactory, _super);
    function DataFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataFactory.read = function (buffer, offset) {
        var identifier = buffer.readInt8(offset);
        offset++;
        switch (identifier) {
            case 1:
                return Int64_1.Int64.read(buffer, offset);
            //let private ByteData = 2uy
            //let private ByteArrayData = 3uy
            case 4:
                return U32_1.U32.read(buffer, offset);
            case 5:
                return UInt64_1.UInt64.read(buffer, offset);
            case 6:
                return Str_1.Str.read(buffer, offset);
            case 7:
                return DataHash_1.DataHash.read(buffer, offset);
            case 8:
                return DataLock_1.DataLock.read(buffer, offset);
            case 9:
                return DataSignature_1.DataSignature.read(buffer, offset);
            case 10:
                return DataPublicKey_1.DataPublicKey.read(buffer, offset);
            //let private CollectionArrayData = 11uy
            case 12:
                return Dictionary_1.Dictionary.read(buffer, offset);
            case 13:
                return DataList_1.default.read(buffer, offset);
            default:
                throw new Error("data identifier: " + identifier + " not yet implemented");
        }
    };
    DataFactory.serialize = function (data) {
        var buffer;
        if (data) {
            buffer = buffer_1.Buffer.alloc(data.getSize());
            data.write(buffer, 0);
            return buffer.toString('hex');
        }
        else
            return '';
    };
    DataFactory.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var data = DataFactory.read(buffer, 0).data;
        return data;
    };
    DataFactory.prototype.write = function (buffer, offset) {
        return 0;
    };
    DataFactory.prototype.getSize = function () {
        return 0;
    };
    DataFactory.prototype.toJson = function () {
        return {};
    };
    return DataFactory;
}(Data_1.Data));
exports.DataFactory = DataFactory;
//# sourceMappingURL=DataFactory.js.map